'use client'
import './polyfills.js';
import { assertPackageVersion } from '@dynamic-labs/assert-package-version';
import { version } from '../package.js';
export { EthereumWalletConnector, createConnector, isEthereumWallet } from '@dynamic-labs/ethereum-core';
export { PhantomEvm } from './injected/PhantomEvm.js';
export { ExodusEvm } from './injected/ExodusEvm.js';
export { FallbackEvmConnector } from './injected/FallbackEvmConnector.js';
export { fetchInjectedWalletConnector, injectedWalletOverrides } from './injected/fetchInjectedWalletConnectors.js';
export { InjectedWalletBase as EthereumInjectedConnector } from './injected/InjectedWalletBase.js';
export { EthProviderHelper } from './ethProviderHelper.js';
export { INFURA_ID } from './constants.js';
export { createInjectedConnector } from './utils/createInjectedConnector/createInjectedConnector.js';
export { EthereumWalletConnectors } from './EthereumWalletConnectors.js';
export { EthereumWalletConnectorsWithConfig } from './EthereumWalletConnectorsWithConfig.js';

assertPackageVersion('@dynamic-labs/ethereum', version);
